import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => (
    <nav className="navbar navbar-expand-md navbar-light navbar-laravel d-none">
        <div className="container">
            <Link className="navbar-brand" to="/crea">
                CRM Lotteries v1.0
            </Link>
        </div>
    </nav>
);

export default Header;
